import React from "react";
import { useParams } from "react-router-dom";
import UserTaskBoardTab from "../portfolio-component/UserTaskBoardTab";

export default function InnovatorTaskBoard({ walletOverride })  {
  const { walletAddress: paramWallet } = useParams();
  const resolvedWallet = walletOverride || paramWallet;

  return <UserTaskBoardTab walletOverride={resolvedWallet?.toLowerCase()} />;
}
